import { IItemDetailActionTypes } from '.';

export const ItemDetailActionTypes: IItemDetailActionTypes = {
  LOAD_ITEM_START: '[itemDetail] LOAD_ITEM_START',

  LOAD_ITEM_RESPONSE_SUCCESS: '[itemDetail] LOAD_ITEM_RESPONSE_SUCCESS',
  LOAD_ITEM_RESPONSE_FAILURE: '[itemDetail] LOAD_ITEM_RESPONSE_FAILURE',

  LOAD_SCORE_GUIDE_SUCCESS: '[itemDetail] LOAD_SCORE_GUIDE_SUCCESS',
  LOAD_SCORE_GUIDE_FAILURE: '[itemDetail] LOAD_SCORE_GUIDE_FAILURE',

  LOAD_SAMPLE_RESPONSES_SUCCESS: '[itemDetail] LOAD_SAMPLE_RESPONSES_SUCCESS',
  LOAD_SAMPLE_RESPONSES_FAILURE: '[itemDetail] LOAD_SAMPLE_RESPONSES_FAILURE',

  LOAD_PERFORMANCE_DATA_START: '[itemDetail] LOAD_PERFORMANCE_DATA_START',
  LOAD_PERFORMANCE_DATA_SUCCESS: '[itemDetail] LOAD_PERFORMANCE_DATA_SUCCESS',
  LOAD_PERFORMANCE_DATA_FAILURE: '[itemDetail] LOAD_PERFORMANCE_DATA_FAILURE'
};


